import { serializeObject } from "@utilities";

const makeRequest = (
    method,
    url,
    data,
    reqTypeHeader = 'application/x-www-form-urlencoded',
    customReqHeaderName,
    customReqHeader
) => {
    if (typeof data === 'object' && data.toString() === {}.toString()) {
        data = serializeObject(data);
    }
    return new Promise(function (resolve, reject) {
        const xhr = new XMLHttpRequest();
        xhr.open(method, url);
        xhr.setRequestHeader('Content-Type', reqTypeHeader);
        if (customReqHeaderName && customReqHeader) {
            xhr.setRequestHeader(customReqHeaderName, customReqHeader);
        }
        xhr.onload = function () {
            if (this.status >= 200 && this.status < 300) {
                resolve(xhr.response);
            } else {
                reject({
                    status: this.status,
                    statusText: xhr.statusText,
                });
            }
        };
        xhr.onerror = function () {
            reject({
                status: this.status,
                statusText: xhr.statusText,
            });
        };
        xhr.send(data);
    });
};

export default makeRequest;
